import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import endMessage from '../utils/endMessage.js';


export default function GameEndingModal({ result, detail, open, setOpen}) {

    // result = {result: win/lose/draw, by: checkmate/repetition/stalemate/timeout}

  const handleClose = () => {
    setOpen('afterGame');
  };

    return (
    <>
       <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Game Ended
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {endMessage(result, detail)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
    )
}